
/**
 * Converts a string into camelcase (e.g. 'My String' -> 'myString')
 * Current usage: making parameters url safe/consistent with existing param value formats
 * Currently used by fetch-view-params -> extractParamData
 * @param {*} str 
 * @returns 
 */
export function toCamelCase(str) {
  const words = str.split(' ');

  const camelCaseWords = words.map((word, index) => {
    if (index === 0) {
      return word.toLowerCase(); // First word is entirely lowercase
    } else {
      // Capitalize the first letter and lowercase the rest for subsequent words
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
  });

  return camelCaseWords.join(''); // Join the words without spaces
}

/**
 * Escapes quotes in faulty expressions
 * e.g. readAll(site and geoCoord).keepCols(["id","dis","geoCoord"]) becomes readAll(site and geoCoord).keepCols([\"id\",\"dis\",\"geoCoord\"])
 * @param {*} jsonStr 
 * @returns 
 */
export function escapeQuotes(jsonStr) {
  // Escape quotes inside JSON strings used in expr values
  return jsonStr.replace(/\[\"/g, '\[\\"').replace(/\"\]/g, '\\"\]').replace(/\"\,\"/g, '\\"\,\\"').replace(/\\\\/g, '\\');
}


/**
 * Cleans faulty objects sent from skyspark as a string
 * Cur use case: when viewData is sent as a string with invalid formatting (has a bunch of \n, spaces, unescaped quotes), convert it into a clean json object
 * @param {*} input 
 * @returns 
 */
export function cleanJSON(input) {
  let data = escapeQuotes(input);
  // let data = input;
  logger.debug('clean json: start', data, input)

  // Keep parsing until it’s no longer a string
  while (typeof data === "string") {
    logger.debug('clean json: is string', data)
    try {
      data = JSON.parse(data);
    } catch (err) {
      // If it fails to parse, clean up escaped newlines/spaces and try once more
      logger.debug('clean json: error parsing', err)
      const cleaned = data
        .replace(/\\n/g, '')   // remove literal "\n"
        .replace(/\n/g, '')    // remove real newlines
        .replace(/\s+/g, ' ')  // collapse spaces
        .trim();
      try {
        data = JSON.parse(cleaned);
      } catch {
        break; // still not valid JSON, so stop
      }
    }
  }

  return data;
}

export function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

